import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import config from '../config';
import { processXhr } from './utils';
var TIMEOUT = 30 * 1000;
export var uploadBundleChunk = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userId, databaseId, seqNo, bundleId, chunkNo, chunk) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var xhr = new XMLHttpRequest();
              var method = 'POST';
              var url = "".concat(config.getEndpoint(), "/api/bundle-chunk?userbaseJsVersion=").concat(config.USERBASE_JS_VERSION, "&") + "userId=".concat(userId, "&") + "databaseId=".concat(databaseId, "&") + "seqNo=".concat(seqNo, "&") + "bundleId=".concat(bundleId, "&") + "chunkNumber=".concat(chunkNo);
              xhr.open(method, url);
              xhr.send(new Uint8Array(chunk)); // Uint8Array view prevents deprecation warning in Safari

              // Uint8Array view prevents deprecation warning in Safari
              processXhr(xhr, resolve, reject, TIMEOUT);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function uploadBundleChunk(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();